export const applicantData = {
  isSuccess: true,
  code: 0,
  message: "string",
  result: {
    postId: 0,
    applicationList: [
      {
        applicationId: 1,
        recruitingId: 0, // 추가
        recruitmentStatus: "OPEN", // 추가
        formId: 0,
        formTitle: "string",
        formDescription: "string",
        clubId: 0,
        clubName: "string",
        postId: 0,
        postTitle: "string",
        applicantId: 101,
        name: "김서아",
        email: "ga@domain.com",
        phoneNum: "01012340001",
        school: "서강대학교",
        major: "컴퓨터공학",
        studentNumber: "20211501",
        positionName: "단장단",
        formResult: "PASS",
        formScore: 95,
        meetingResult: "PENDING",
        meetingScore: 85,
        meetingStartTime: "2024-01-01T12:00:00.000Z",
        meetingEndTime: "2024-01-01T12:30:00.000Z",
        answers: [
          {
            questionId: 0,
            question: "string",
            answer: "string",
            score: 0,
            questionType: "TEXT",
          },
        ],
      },
      {
        applicationId: 2,
        recruitingId: 0, // 추가
        recruitmentStatus: "OPEN", // 추가
        formId: 0,
        formTitle: "string",
        formDescription: "string",
        clubId: 0,
        clubName: "string",
        postId: 0,
        postTitle: "string",
        applicantId: 102,
        name: "나서아",
        email: "na@domain.com",
        phoneNum: "01012340002",
        school: "서강대학교",
        major: "심리학",
        studentNumber: "20211502",
        positionName: "단장단",
        formResult: "PASS",
        formScore: 88,
        meetingResult: "PENDING",
        meetingScore: 90,
        meetingStartTime: "2024-01-02T13:00:00.000Z",
        meetingEndTime: "2024-01-02T13:30:00.000Z",
        answers: [
          {
            questionId: 0,
            question: "string",
            answer: "string",
            score: 0,
            questionType: "TEXT",
          },
        ],
      },
      {
        applicationId: 3,
        recruitingId: 0, // 추가
        recruitmentStatus: "OPEN", // 추가
        formId: 0,
        formTitle: "string",
        formDescription: "string",
        clubId: 0,
        clubName: "string",
        postId: 0,
        postTitle: "string",
        applicantId: 103,
        name: "다서아",
        email: "da@domain.com",
        phoneNum: "01012340003",
        school: "서강대학교",
        major: "경영학",
        studentNumber: "20211503",
        positionName: "단장단",
        formResult: "PASS",
        formScore: 92,
        meetingResult: "PASS",
        meetingScore: 88,
        meetingStartTime: "2024-01-03T14:00:00.000Z",
        meetingEndTime: "2024-01-03T14:30:00.000Z",
        answers: [
          {
            questionId: 0,
            question: "string",
            answer: "string",
            score: 0,
            questionType: "TEXT",
          },
        ],
      },
      {
        applicationId: 4,
        recruitingId: 0, // 추가
        recruitmentStatus: "OPEN", // 추가
        formId: 0,
        formTitle: "string",
        formDescription: "string",
        clubId: 0,
        clubName: "string",
        postId: 0,
        postTitle: "string",
        applicantId: 104,
        name: "라서아",
        email: "ra@domain.com",
        phoneNum: "01012340004",
        school: "서강대학교",
        major: "수학",
        studentNumber: "20211504",
        positionName: "단장단",
        formResult: "FAIL",
        formScore: 85,
        meetingResult: "FAIL",
        meetingScore: 70,
        meetingStartTime: "",
        meetingEndTime: "",
        answers: [
          {
            questionId: 0,
            question: "string",
            answer: "string",
            score: 0,
            questionType: "TEXT",
          },
        ],
      },
      {
        applicationId: 5,
        recruitingId: 0, // 추가
        recruitmentStatus: "OPEN", // 추가
        formId: 0,
        formTitle: "string",
        formDescription: "string",
        clubId: 0,
        clubName: "string",
        postId: 0,
        postTitle: "string",
        applicantId: 105,
        name: "마서아",
        email: "ma@domain.com",
        phoneNum: "01012340005",
        school: "서강대학교",
        major: "철학",
        studentNumber: "20211505",
        positionName: "단장단",
        formResult: "PASS",
        formScore: 78,
        meetingResult: "FAIL",
        meetingScore: 68,
        meetingStartTime: "2024-01-05T16:00:00.000Z",
        meetingEndTime: "2024-01-05T16:30:00.000Z",
        answers: [
          {
            questionId: 0,
            question: "string",
            answer: "string",
            score: 0,
            questionType: "TEXT",
          },
        ],
      },
      {
        applicationId: 6,
        recruitingId: 0, // 추가
        recruitmentStatus: "OPEN", // 추가
        formId: 0,
        formTitle: "string",
        formDescription: "string",
        clubId: 0,
        clubName: "string",
        postId: 0,
        postTitle: "string",
        applicantId: 106,
        name: "바서아",
        email: "ba@domain.com",
        phoneNum: "01012340001",
        school: "서강대학교",
        major: "기계공학학",
        studentNumber: "20211506",
        positionName: "단장단",
        formResult: "PASS",
        formScore: 95,
        meetingResult: "PASS",
        meetingScore: 85,
        meetingStartTime: "2024-01-01T12:00:00.000Z",
        meetingEndTime: "2024-01-01T12:30:00.000Z",
        answers: [
          {
            questionId: 0,
            question: "string",
            answer: "string",
            score: 0,
            questionType: "TEXT",
          },
        ],
      },
      {
        applicationId: 7,
        recruitingId: 0, // 추가
        recruitmentStatus: "OPEN", // 추가
        formId: 0,
        formTitle: "string",
        formDescription: "string",
        clubId: 0,
        clubName: "string",
        postId: 0,
        postTitle: "string",
        applicantId: 107,
        name: "아서아",
        email: "a@domain.com",
        phoneNum: "01012340001",
        school: "서강대학교",
        major: "화학",
        studentNumber: "20211507",
        positionName: "단장단",
        formResult: "PASS",
        formScore: 95,
        meetingResult: "PASS",
        meetingScore: 85,
        meetingStartTime: "2024-01-01T12:00:00.000Z",
        meetingEndTime: "2024-01-01T12:30:00.000Z",
        answers: [
          {
            questionId: 0,
            question: "string",
            answer: "string",
            score: 0,
            questionType: "TEXT",
          },
        ],
      },
      {
        applicationId: 8,
        recruitingId: 0, // 추가
        recruitmentStatus: "OPEN", // 추가
        formId: 0,
        formTitle: "string",
        formDescription: "string",
        clubId: 0,
        clubName: "string",
        postId: 0,
        postTitle: "string",
        applicantId: 108,
        name: "자서아",
        email: "ja@domain.com",
        phoneNum: "01012340001",
        school: "서강대학교",
        major: "유럽문화학학",
        studentNumber: "20211508",
        positionName: "단장단",
        formResult: "FAIL",
        formScore: 95,
        meetingResult: "FAIL",
        meetingScore: 85,
        meetingStartTime: "2024-01-01T12:00:00.000Z",
        meetingEndTime: "2024-01-01T12:30:00.000Z",
        answers: [
          {
            questionId: 0,
            question: "string",
            answer: "string",
            score: 0,
            questionType: "TEXT",
          },
        ],
      },
      {
        applicationId: 9,
        recruitingId: 0, // 추가
        recruitmentStatus: "OPEN", // 추가
        formId: 0,
        formTitle: "string",
        formDescription: "string",
        clubId: 0,
        clubName: "string",
        postId: 0,
        postTitle: "string",
        applicantId: 109,
        name: "차서아",
        email: "cha@domain.com",
        phoneNum: "01012340001",
        school: "서강대학교",
        major: "컴퓨터공학",
        studentNumber: "20211509",
        positionName: "단장단",
        formResult: "PASS",
        formScore: 95,
        meetingResult: "PENDING",
        meetingScore: 85,
        meetingStartTime: "2024-01-01T12:00:00.000Z",
        meetingEndTime: "2024-01-01T12:30:00.000Z",
        answers: [
          {
            questionId: 0,
            question: "string",
            answer: "string",
            score: 0,
            questionType: "TEXT",
          },
        ],
      },
      {
        applicationId: 10,
        recruitingId: 0, // 추가
        recruitmentStatus: "OPEN", // 추가
        formId: 0,
        formTitle: "string",
        formDescription: "string",
        clubId: 0,
        clubName: "string",
        postId: 0,
        postTitle: "string",
        applicantId: 110,
        name: "카서아",
        email: "Ka@domain.com",
        phoneNum: "01012340001",
        school: "서강대학교",
        major: "미디어&엔터테인먼트",
        studentNumber: "20211510",
        positionName: "단장단",
        formResult: "PASS",
        formScore: 95,
        meetingResult: "FAIL",
        meetingScore: 85,
        meetingStartTime: "2024-01-01T12:00:00.000Z",
        meetingEndTime: "2024-01-01T12:30:00.000Z",
        answers: [
          {
            questionId: 0,
            question: "string",
            answer: "string",
            score: 0,
            questionType: "TEXT",
          },
        ],
      },
    ],
  },
};
